(function () {
  function initializeJudgeDots(widget) {
    if (widget.dataset.nfbDotsInitialized === "true") return;

    const carousel = widget.querySelector(".jdgm-testimonials-container");
    const slides = Array.from(
      carousel?.querySelectorAll(".jdgm-carousel-item") || []
    );

    slides.forEach((slide) => {
      const nameElement = slide.querySelector(".jdgm-reviewer-name");
      if (!nameElement) return;

      const nameParts = nameElement.textContent.trim().split(/\s+/);

      if (nameParts.length < 2) return;

      const rawFirstName = nameParts[0].toLowerCase();
      const firstName =
        rawFirstName.charAt(0).toUpperCase() + rawFirstName.slice(1);

      const lastInitial = nameParts[nameParts.length - 1]
        .charAt(0)
        .toUpperCase();

      nameElement.textContent = `${firstName} ${lastInitial}.`;
    });

    const previousButton = widget.querySelector(
      '.jdgm-arrow[aria-label="Previous slide"]'
    );

    const nextButton = widget.querySelector(
      '.jdgm-arrow[aria-label="Next slide"]'
    );

    if (slides.length < 2 || !previousButton || !nextButton) return;

    widget.dataset.nfbDotsInitialized = "true";

    const dotsContainer = document.createElement("div");
    dotsContainer.className = "nfb-judge-dots";
    dotsContainer.setAttribute("role", "group");
    dotsContainer.setAttribute("aria-label", "Choose testimonial");

    const dots = slides.map((slide, index) => {
      const dot = document.createElement("button");

      dot.type = "button";
      dot.className = "nfb-judge-dot";
      dot.setAttribute("aria-label", `Show testimonial ${index + 1}`);

      dot.addEventListener("click", function () {
        const currentIndex = slides.findIndex((item) =>
          item.classList.contains("active")
        );

        if (currentIndex < 0 || currentIndex === index) return;

        const forwardSteps =
          (index - currentIndex + slides.length) % slides.length;

        const backwardSteps =
          (currentIndex - index + slides.length) % slides.length;

        const button =
          forwardSteps <= backwardSteps ? nextButton : previousButton;

        const steps = Math.min(forwardSteps, backwardSteps);

        for (let step = 0; step < steps; step++) {
          button.click();
        }
      });

      dotsContainer.appendChild(dot);

      return dot;
    });

    const arrows = widget.querySelector(".jdgm-arrows--bottom");

    arrows.insertAdjacentElement("afterend", dotsContainer);

    function updateDots() {
      const activeIndex = slides.findIndex((slide) =>
        slide.classList.contains("active")
      );

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;

        dot.classList.toggle("is-active", isActive);

        dot.setAttribute(
          "aria-current",
          isActive ? "true" : "false"
        );
      });
    }

    const observer = new MutationObserver(updateDots);

    slides.forEach((slide) => {
      observer.observe(slide, {
        attributes: true,
        attributeFilter: ["class"]
      });
    });

    updateDots();
  }

  function initialize() {
    document.querySelectorAll(".jdgm-widget").forEach(initializeJudgeDots);
  }

  const observer = new MutationObserver(initialize);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  initialize();
})();